import { render, staticRenderFns } from "./InsuranceAuthorization.vue?vue&type=template&id=3f505304&scoped=true&"
import script from "./InsuranceAuthorization.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAuthorization.vue?vue&type=style&index=0&id=3f505304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f505304",
  null
  
)

export default component.exports